export default __webpack_public_path__ + "static/media/Group 7.cc8641bd.png";